import Vue from 'vue'

function backToTopClicked (isIconButton = false) {
  const subject = isIconButton ? 'ICON BUTTON' : 'FULL NAME BUTTON'

  return {
    event: 'backToTopClicked',
    attributes: {
      subject,
    },
  }
}

const trackBackToTopClicked = () => {
  const event = backToTopClicked()

  Vue.$clickstream.trackEvent(event)
}

export default {
  trackBackToTopClicked,
}
